(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elegance-video-gif"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elegance-video-showcase')) {
 customElements.define('elegance-video-showcase', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   const video = this.querySelector('.feature-film');
   const overlay = this.querySelector('button.feature-overlay');
   if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    this.clipObserver = new IntersectionObserver(entries => {
     entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const clip = entry.target;
      clip.muted = true;
      const play = clip.play();
      if (play) play.catch(() => {});
      this.clipObserver.unobserve(clip);
     });
    }, { threshold: 0.25 });
    this.querySelectorAll('.short-film').forEach(clip => this.clipObserver.observe(clip));
   }
   if (video && overlay) {
    overlay.hidden = false;
    overlay.addEventListener('click', () => {
     overlay.hidden = true;
     video.controls = true;
     video.focus();
     const play = video.play();
     if (play) play.catch(() => { overlay.hidden = false; });
    });
   }
  }
  disconnectedCallback() {
   if (this.clipObserver) this.clipObserver.disconnect();
   this.querySelectorAll('video').forEach(video => video.pause());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["embroidery-section"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elegance-embroidery-explorer')) {
 customElements.define('elegance-embroidery-explorer', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.tabs = Array.from(this.querySelectorAll('[role=tab]'));
   this.panels = Array.from(this.querySelectorAll('[role=tabpanel]'));
   if (!this.tabs.length) return;
   this.index = 0;
   this.mobile = window.matchMedia('(max-width:900px)');
   this.reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
   const orient = () => this.querySelector('[role=tablist]').setAttribute('aria-orientation',this.mobile.matches?'horizontal':'vertical');
   orient();
   this.mobile.addEventListener('change',orient,options);
   this.tabs.forEach((tab,i) => {
    tab.addEventListener('click',() => this.select(i),options);
    tab.addEventListener('keydown',event => {
     const next = this.mobile.matches?'ArrowRight':'ArrowDown';
     const previous = this.mobile.matches?'ArrowLeft':'ArrowUp';
     let target;
     if(event.key===next) target=i+1;
     else if(event.key===previous) target=i-1;
     else if(event.key==='Home') target=0;
     else if(event.key==='End') target=this.tabs.length-1;
     if(target!==undefined){event.preventDefault();this.select(target,true);}
    },options);
   });
   this.querySelector('[data-prev]').addEventListener('click',()=>this.select(this.index-1),options);
   this.querySelector('[data-next]').addEventListener('click',()=>this.select(this.index+1),options);
   document.addEventListener('shopify:block:select',event=>{
    const i=this.tabs.findIndex(tab=>tab.dataset.blockId===event.detail.blockId);
    if(i>=0)this.select(i);
   },options);
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries=>{
     this.visible=entries[0].isIntersecting;
     if(this.visible)this.playActive();
     else this.querySelectorAll('video').forEach(video=>video.pause());
    },{threshold:0.1});
    this.observer.observe(this.querySelector('.fx-stage'));
   }
  }
  select(index,focus=false) {
   this.index=(index+this.tabs.length)%this.tabs.length;
   this.tabs.forEach((tab,i)=>{
    const active=i===this.index;
    tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;
    this.panels[i].hidden=!active;
    if(!active)this.panels[i].querySelectorAll('video').forEach(video=>video.pause());
   });
   this.querySelector('[data-count]').textContent=this.index+1;
   const tab=this.tabs[this.index];
   if(focus)tab.focus({preventScroll:true});
   if(this.mobile.matches) {
    const list=tab.parentElement;
    list.scrollTo({left:tab.offsetLeft-list.offsetLeft-(list.clientWidth-tab.offsetWidth)/2,behavior:this.reduce.matches?'auto':'smooth'});
   }
   this.playActive();
  }
  playActive() {
   if(!this.visible || this.dataset.autoplay!=='true' || this.reduce.matches)return;
   const video=this.panels[this.index].querySelector('video');
   if(video){video.muted=true;const play=video.play();if(play)play.catch(()=>{});}
  }
  disconnectedCallback() {
   this.abort?.abort();this.abort=null;this.observer?.disconnect();
   this.querySelectorAll('video').forEach(video=>video.pause());
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  const UNMATCHING_COUNTRIES = {
  Afghanistan: 'Afghanistan',
  Albania: 'Albania',
  Algeria: 'Algeria',
  Armenia: 'Armenia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaijan',
  Bahrain: 'Bahrain',
  Bangladesh: 'Bangladesh',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Benin: 'Benin',
  Bhutan: 'Bhutan',
  Bolivia: 'Bolivia, Plurinational State of',
  'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
  Brazil: 'Brazil',
  'British Virgin Islands': 'Virgin Islands, British',
  Bulgaria: 'Bulgaria',
  Burundi: 'Burundi',
  Cambodia: 'Cambodia',
  Cameroon: 'Cameroon',
  'Cape Verde': 'Cape Verde',
  'Central African Republic': 'Central African Republic',
  Chad: 'Chad',
  China: 'China',
  Comoros: 'Comoros',
  Congo: 'Congo',
  'Côte d’Ivoire': "Cote d'Ivoire",
  Croatia: 'Croatia',
  Cyprus: 'Cyprus',
  'Czech Republic': 'Czech Republic',
  Denmark: 'Denmark',
  'Dominican Republic': 'Dominican Republic',
  Egypt: 'Egypt',
  'Equatorial Guinea': 'Equatorial Guinea',
  Estonia: 'Estonia',
  'Faroe Islands': 'Faroe Islands',
  'Finland (Suomi)': 'Finland',
  'French Guiana': 'French Guiana',
  'French Polynesia': 'French Polynesia',
  Georgia: 'Georgia',
  Germany: 'Germany',
  Ghana: 'Ghana',
  Greece: 'Greece',
  Greenland: 'Greenland',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bissau',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  India: 'India',
  Iran: 'Iran, Islamic Republic of',
  Iraq: 'Iraq',
  Israel: 'Israel',
  Italy: 'Italy',
  Japan: 'Japan',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kyrgyzstan',
  Laos: "Lao People's Democratic Republic",
  Latvia: 'Latvia',
  Lebanon: 'Lebanon',
  Libya: 'Libya',
  Lithuania: 'Lithuania',
  Macau: 'Macao',
  Macedonia: 'Macedonia, the former Yugoslav Republic of',
  Madagascar: 'Madagascar',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Mexico: 'Mexico',
  Moldova: 'Moldova, Republic of',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Morocco: 'Morocco',
  Mozambique: 'Mozambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namibia',
  Nepal: 'Nepal',
  'New Caledonia': 'New Caledonia',
  Netherlands: 'Netherlands',
  Niger: 'Niger',
  'North Korea': "Korea, Democratic People's Republic of",
  Norway: 'Norway',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palestine: 'Palestine',
  Panama: 'Panama',
  Peru: 'Peru',
  Poland: 'Poland',
  Qatar: 'Qatar',
  Réunion: 'Reunion',
  Romania: 'Romania',
  Russia: 'Russian Federation',
  'Saint Helena': 'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Barthélemy': 'Saint Barthélemy',
  'Saint Martin': 'Saint Martin (French part)',
  'Saint Pierre and Miquelon': 'Saint Pierre and Miquelon',
  'São Tomé and Príncipe': 'Sao Tome and Principe',
  'Saudi Arabia': 'Saudi Arabia',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  'Sint Maarten': 'Sint Maarten (Dutch part)',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Somalia: 'Somalia',
  'South Korea': 'Korea, Republic of',
  'South Sudan': 'South Sudan',
  Spain: 'Spain',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudan',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Syria: 'Syrian Arab Republic',
  Taiwan: 'Taiwan',
  Tanzania: 'Tanzania, United Republic of',
  Thailand: 'Thailand',
  Tunisia: 'Tunisia',
  Turkey: 'Turkey',
  Venezuela: 'Venezuela, Bolivarian Republic of',
  'U.S. Virgin Islands': 'Virgin Islands, U.S.',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'United Arab Emirates',
  Uzbekistan: 'Uzbekistan',
  Vietnam: 'Vietnam',
  Yemen: 'Yemen',
};
  
  function getCountryCodeNodes() {
    return document.querySelectorAll('.hs-fieldtype-intl-phone>select.hs-input');
  }

  // Query country selection form
  function getCountrySelectionNodes() {
    return document.querySelectorAll('.hs-country input');
  }
  
  // Query country choices in form
  function getCountryChoices() {
    return Array.from(getCountryCodeNodes().item(0).querySelectorAll('option')).reduce(
      (acc, country) => {
        acc[country.value] = country.innerHTML.replace(/ *\([^)]*\) */g, '').trim();
        return acc;
      },
      {}
    );
  }
  // Queries default country from phone and establishes default country in country field
  function setSelectedDefaultNodeCountry(
    countryCodeNodes,
    countrySelectionNodes,
    countryChoices
  ) {
    countryCodeNodes.forEach((countryCodeNode) => {
      const countryCode = countryCodeNode.value;
      const countryName = countryChoices[countryCode];
      countrySelectionNodes.forEach((countrySelectionNode) => {
        countrySelectionNode.value =
          countryName ?? UNMATCHING_COUNTRIES[countryName] ?? countryChoices['US'];
      });
    });
  }
  
  function hubspotFormChangeCountry() {
    const countryCodeNodes = getCountryCodeNodes();
    const countrySelectionNodes = getCountrySelectionNodes();
    const countryChoices = getCountryChoices();
  
    setSelectedDefaultNodeCountry(countryCodeNodes, countrySelectionNodes, countryChoices);
  
    countryCodeNodes.forEach((countryCodeNode) => {
      countryCodeNode.addEventListener('change', (e) => {
        const countryCode = (e.target).value;
        const countryName = countryChoices[countryCode];
        countrySelectionNodes.forEach((countrySelectionNode) => {
          countrySelectionNode.value =
            UNMATCHING_COUNTRIES[countryName] ?? countryName ?? countryChoices['US'];
        });
      });
    });
  }

  if(document.getElementById("openModal1")){
    document.getElementById("openModal1").onclick = function() {
      document.getElementById("modal1").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }

    document.getElementById("closeModal1").onclick = function() {
      document.getElementById("modal1").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }

  }


  if(document.getElementById("openModal2")){
    document.getElementById("openModal2").onclick = function() {
      document.getElementById("modal2").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }

    document.getElementById("closeModal2").onclick = function() {
      document.getElementById("modal2").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }
  }

  if(document.getElementById("openModal4")){
    document.getElementById("openModal4").onclick = function() {
      document.getElementById("modal4").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }

    document.getElementById("closeModal4").onclick = function() {
      document.getElementById("modal4").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }

  }

  if(document.getElementById("openModal3")){
    document.getElementById("openModal3").onclick = function() {
      document.getElementById("modal3").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }
  }

  if(document.getElementById("closeModal3")){
    document.getElementById("closeModal3").onclick = function() {
      document.getElementById("modal3").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }
  }

  const triggers = document.querySelectorAll('a[href="#modal3"], button[href="#modal3"]');
  triggers.forEach(el => {
    el.addEventListener("click", e => {
      e.preventDefault();               // stop the browser from jumping to #modal3
      document.getElementById("modal3").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    });
  });

  const triggers4 = document.querySelectorAll('a[href="#modal4"], button[href="#modal4"]');
  triggers4.forEach(el => {
    el.addEventListener("click", e => {
      e.preventDefault();               // stop the browser from jumping to #modal3
      document.getElementById("modal4").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    });
  });

  const triggers1 = document.querySelectorAll('a[href="#modal1"], button[href="#modal1"]');
  triggers1.forEach(el => {
    el.addEventListener("click", e => {
      e.preventDefault();               // stop the browser from jumping to #modal3
      document.getElementById("modal1").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    });
  });

  const triggers2 = document.querySelectorAll('a[href="#modal2"], button[href="#modal2"]');
  triggers2.forEach(el => {
    el.addEventListener("click", e => {
      e.preventDefault();               // stop the browser from jumping to #modal3
      document.getElementById("modal2").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    });
  });

  window.addEventListener('load', function () {
    hubspotFormChangeCountry();
  })

window.onclick = function(event) {
  if (event.target == document.getElementById("modal1")) {
    document.getElementById("modal1").style.display = "none";
  }
  if (event.target == document.getElementById("modal2")) {
    document.getElementById("modal2").style.display = "none";
  }
  if (event.target == document.getElementById("modal3")) {
    document.getElementById("modal3").style.display = "none";
  }
  if (event.target == document.getElementById("modal4")) {
    document.getElementById("modal4").style.display = "none";
  }
}



  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewing-section"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elegance-feature-explorer')) {
 customElements.define('elegance-feature-explorer', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.tabs = Array.from(this.querySelectorAll('[role=tab]'));
   this.panels = Array.from(this.querySelectorAll('[role=tabpanel]'));
   if (!this.tabs.length) return;
   this.index = 0;
   this.mobile = window.matchMedia('(max-width:900px)');
   this.reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
   const orient = () => this.querySelector('[role=tablist]').setAttribute('aria-orientation',this.mobile.matches?'horizontal':'vertical');
   orient();
   this.mobile.addEventListener('change',orient,options);
   this.tabs.forEach((tab,i) => {
    tab.addEventListener('click',() => this.select(i),options);
    tab.addEventListener('keydown',event => {
     const next = this.mobile.matches?'ArrowRight':'ArrowDown';
     const previous = this.mobile.matches?'ArrowLeft':'ArrowUp';
     let target;
     if(event.key===next) target=i+1;
     else if(event.key===previous) target=i-1;
     else if(event.key==='Home') target=0;
     else if(event.key==='End') target=this.tabs.length-1;
     if(target!==undefined){event.preventDefault();this.select(target,true);}
    },options);
   });
   this.querySelector('[data-prev]').addEventListener('click',()=>this.select(this.index-1),options);
   this.querySelector('[data-next]').addEventListener('click',()=>this.select(this.index+1),options);
   document.addEventListener('shopify:block:select',event=>{
    const i=this.tabs.findIndex(tab=>tab.dataset.blockId===event.detail.blockId);
    if(i>=0)this.select(i);
   },options);
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries=>{
     this.visible=entries[0].isIntersecting;
     if(this.visible)this.playActive();
     else this.querySelectorAll('video').forEach(video=>video.pause());
    },{threshold:0.1});
    this.observer.observe(this.querySelector('.fx-stage'));
   }
  }
  select(index,focus=false) {
   this.index=(index+this.tabs.length)%this.tabs.length;
   this.tabs.forEach((tab,i)=>{
    const active=i===this.index;
    tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;
    this.panels[i].hidden=!active;
    if(!active)this.panels[i].querySelectorAll('video').forEach(video=>video.pause());
   });
   this.querySelector('[data-count]').textContent=this.index+1;
   const tab=this.tabs[this.index];
   if(focus)tab.focus({preventScroll:true});
   if(this.mobile.matches) {
    const list=tab.parentElement;
    list.scrollTo({left:tab.offsetLeft-list.offsetLeft-(list.clientWidth-tab.offsetWidth)/2,behavior:this.reduce.matches?'auto':'smooth'});
   }
   this.playActive();
  }
  playActive() {
   if(!this.visible || this.dataset.autoplay!=='true' || this.reduce.matches)return;
   const video=this.panels[this.index].querySelector('video');
   if(video){video.muted=true;const play=video.play();if(play)play.catch(()=>{});}
  }
  disconnectedCallback() {
   this.abort?.abort();this.abort=null;this.observer?.disconnect();
   this.querySelectorAll('video').forEach(video=>video.pause());
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
